__turbopack_context__.v({
  "digits": "dnumeral-module__uOTHIa__digits",
  "numeral": "dnumeral-module__uOTHIa__numeral",
  "suffix": "dnumeral-module__uOTHIa__suffix",
});
